export default __webpack_public_path__ + "static/media/casaduana_IrvingBecerril.73f60b6b.jpg";